import React from 'react';
import Button, { ButtonProps } from '../../v2BaseComponents/Button';
import { useIsMobileLayout } from '../../../hooks/useIsMobileLayout';
import Stack from '../../v2BaseComponents/Stack';
import { StyleProp, ViewStyle } from 'react-native';

export type MaybeStackedButtonsOwnProps = {
    primaryButtonProps: ButtonProps;
    secondaryButtonProps?: ButtonProps;
    style?: StyleProp<ViewStyle>;
    forceStack?: boolean;
};

export type MaybeStackedButtonsProps = MaybeStackedButtonsOwnProps;

const MaybeStackedButtons: React.FC<MaybeStackedButtonsProps> = (props) => {
    const isMobile = useIsMobileLayout();

    if (isMobile || props.forceStack) {
        return (
            <Stack vertical fullWidth space={3} style={props.style} align="center">
                <Button {...props.primaryButtonProps} size="lg" />
                {props.secondaryButtonProps ? <Button {...props.secondaryButtonProps} size="lg" /> : null}
            </Stack>
        );
    } else {
        return (
            <Stack horizontal fullWidth space={3} justify="center" align="center" style={props.style}>
                {props.secondaryButtonProps ? (
                    <Button {...props.secondaryButtonProps} size="lg" style={{ flex: 1 }} />
                ) : null}
                <Button
                    {...props.primaryButtonProps}
                    size="lg"
                    style={{ flex: props.secondaryButtonProps ? 1 : undefined }}
                />
            </Stack>
        );
    }
};

export default React.memo(MaybeStackedButtons);
